// extracted by mini-css-extract-plugin
export default {"item":"styles_item__Clpwn","label":"styles_label__5vSC0","disabled":"styles_disabled__HJ8Wz"};